import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { routes } from '../../routes';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { TabContext, TabPanel } from '@mui/lab';
import { t } from 'i18next';
import { AnimatePresence, motion } from 'framer-motion';
import { Button, useMediaQuery, useTheme } from '@mui/material';
import { Icon } from '@iconify/react';
import { Add } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { setTrackLibraryModal, setTrackNameModal } from '../../../store/reducers/modal.reducer';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
const pageVariants = {
    initial: { opacity: 0, y: 10, scale: 0.98 },
    animate: { opacity: 1, y: 0, scale: 1 },
    exit: { opacity: 0, y: -10, scale: 0.98 }
};
export default function Qualifications() {
    const [value, setValue] = React.useState('0');
    const [children, setChildren] = React.useState<React.ReactNode>(null)
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // Check if screen is small


    const tabs = [
        {
            title: "navbar:myTrainingTypes",
            route: routes.DASHBOARD_ROUTES.TRAININGTYPE,
            index: '0',
        },
        {
            title: 'navbar:myTracks',
            index: '1',
            route: routes.DASHBOARD_ROUTES.TRACKS,
            children: <Box display={'flex'} gap={2} justifyContent={'end'} pb={2} alignItems={'center'} flexWrap={'wrap'}>
                <Button onClick={() => dispatch(setTrackLibraryModal(true))} variant='contained' startIcon={<Icon icon={'proicons:library'}></Icon>}>{t('selectFromLib')}</Button>
                <Button onClick={() => dispatch(setTrackNameModal(true))} variant='contained' startIcon={<Add></Add>}>{t('tracks:addTrack')}</Button>

            </Box>
        },
        {
            title: "navbar:myTrackConditions",
            route: routes.DASHBOARD_ROUTES.TRACKSCONDITIONS,
            index: '2',
        },
        {
            title: "navbar:myRiders",
            route: routes.DASHBOARD_ROUTES.RIDERS,
            index: '3',
        },
        {
            title: "navbar:myShoeing",
            index: '4',
            route: routes.DASHBOARD_ROUTES.SHOEING
        },



    ]



    React.useEffect(() => {
        let { pathname } = location

        let route = tabs.find(tab => tab.route === pathname)
        // onRouteChanged(route?.title, route?.children)
        if (route) {
            setValue(route.index)
            setChildren(route?.children)

        } else {
            // if (pathname.includes('tracks')) {
            //     let sub = tabs.find(e => e.value === routes.DASHBOARD_ROUTES.TRACKS)
            //     setValue(sub?.index ?? '5')
            //     onRouteChanged(sub?.title, sub?.children)

            // }
        }
    }, [location.pathname])


    const handleChange = (event: React.SyntheticEvent, newValue: string) => {


        let route = tabs.find(tab => tab.index === newValue)

        if (route) {
            let path = route.route
            setChildren(route?.children)
            navigate(path)

        }

    };





    return (
        <Box
            sx={{ display: 'flex', height: '100%', minHeight: '70vh', flexDirection: isSmallScreen ? 'column' : 'row' }}
        >
            <Tabs
                orientation={isSmallScreen ? 'horizontal' : "vertical"}
                variant="scrollable"
                scrollButtons='auto'
                value={value}
                onChange={handleChange}
                sx={{ borderRight: 1, borderColor: 'divider', borderRadius: 0 }}
            >
                {tabs.map((tab, i) => (
                    <Tab key={tab.index} label={<Typography variant='subtitle2' >{t(tab.title)}</Typography>} value={tab.index} />
                ))}
            </Tabs>
            <Box p={3} width={'100%'} sx={{ bgcolor: 'background.paper', overflowX: 'hidden' }}>
                <motion.div
                    key={location.pathname}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                    variants={pageVariants}
                    transition={{ duration: 0.2, ease: "easeInOut" }}
                >
                    {
                        children
                    }
                    <Outlet />
                </motion.div>
            </Box>

        </Box>
    );
}